import { render, staticRenderFns } from "./Emotion.vue?vue&type=template&id=dfd51b76&scoped=true"
import script from "./Emotion.vue?vue&type=script&lang=js"
export * from "./Emotion.vue?vue&type=script&lang=js"
import style0 from "./Emotion.vue?vue&type=style&index=0&id=dfd51b76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd51b76",
  null
  
)

export default component.exports